export const businessActivitiesLocation = "/reports/exchbusiness/actinperiod";
